import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

/**
 * LogRocket'i başlatır
 */
export const initLogRocket = () => {
  const logRocketKey = process.env.VUE_APP_LOG_ROCKET_KEY;
  const isProduction = process.env.NODE_ENV === 'production';
  const isEnabled = process.env.VUE_APP_ENABLE_LOGROCKET === 'true' || isProduction;

  if (logRocketKey && isEnabled) {
    LogRocket.init(logRocketKey, {
      dom: {
        inputSanitizer: true
      }
    });
  }
};

/**
 * Vuex plugin'ini oluşturur
 */
export const logRocketPlugin = createPlugin(LogRocket);

export default LogRocket;
